// v3
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        // FIX: Do NOT resolve this.cart in the constructor.
        // All scripts are defer-loaded; when the constructor runs, cart-drawer.js
        // may not have executed yet, so document.querySelector('cart-drawer')
        // returns a plain HTMLElement with no getSectionsToRender method.
        // We resolve it lazily inside onSubmitHandler instead.
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // Lazy getter — resolved fresh on every submit, after all scripts have loaded
      get cart() {
        return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const cart = this.cart; // snapshot for this submission
        const formData = new FormData(this.form);
        if (!formData.has('quantity') || formData.get('quantity') === '') {
          const cartRow = this.closest ? this.closest('.pdp__cart-row, .pdp__info, .pdp, section, .product') : null;
          const qtyInput = (this.form && this.form.id ? document.querySelector(`[name="quantity"][form="${this.form.id}"]`) : null)
            || (cartRow ? cartRow.querySelector('.pdp__qty-input, [name="quantity"]') : null)
            || (this.form && this.form.elements ? this.form.elements['quantity'] : null);
          if (qtyInput && qtyInput.value) {
            formData.set('quantity', qtyInput.value);
          }
        }

        if (cart) {
          // Guard: only call getSectionsToRender if the custom element has upgraded
          if (typeof cart.getSectionsToRender === 'function') {
            formData.append(
              'sections',
              cart.getSectionsToRender().map((section) => section.id).join(',')
            );
          }
          formData.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') {
            cart.setActiveElement(document.activeElement);
          }
        }
        config.body = formData;

        const pristineFetch = window.__nativeFetch || window.fetch;

        pristineFetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // FIX: Wait for all cartUpdate subscribers (inc. Planet Discounts) to
            // settle before calling renderContents, so the drawer shows correct
            // post-discount state. Use .finally() so a failing subscriber never
            // silently prevents the drawer from opening.
            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');

            const publishPromise = !this.error
              ? Promise.resolve(
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    cartData: response,
                  })
                )
              : Promise.resolve();

            this.error = false;

            publishPromise
              .then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              })
              .catch((e) => {
                console.error('cartUpdate subscriber error:', e);
              })
              .finally(() => {
                if (typeof cart.renderContents !== 'function') return;

                CartPerformance.measure('add:paint-updated-sections', () => {
                  const quickAddModal = this.closest('quick-add-modal');
                  if (quickAddModal) {
                    document.body.addEventListener(
                      'modalClosed',
                      () => {
                        setTimeout(() => {
                          cart.renderContents(response);
                        });
                      },
                      { once: true }
                    );
                    quickAddModal.hide(true);
                  } else {
                    cart.renderContents(response);
                  }
                });
              });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            const currentCart = this.cart;
            if (currentCart && currentCart.classList.contains('is-empty'))
              currentCart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}